import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/src/components/common/news-page/news-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/src/components/journal-site/_partials/header/journal-header.tsx");
